import { NavbarItemType } from "./types";

export const NAVBAR_ITEMS: NavbarItemType[] = [
    {
        path: "/portfolio",
    },
    {
        path: "/activity",
    },
    {
        path: "/",
    },
    {
        path: "/reward",
    },
    {
        // path: "/setting",
        path: "/mission",
    },
];

export enum REWARD_TABS {
    PERSONAL = "personal",
    RANK = "rank",
}

export const authConfig: NavbarItemType[] = [
    {
        path: "/connect",
        requireNoLogin: true,
    },
];

export enum RESPONSE_STATUS {
    SUCCESS = "success",
    FAILED = "failed",
    PROCESSING = "processing",
    CANCEL = "cancel",
}

export enum KYC_STATUS {
    REJECTED = "rejected",
    REQUESTED = "requested",
    VERIFIED = "verified",
}

export const ACTIVITY_TYPE = {
    PRE_SALE: "",
    CLAIM_REWARD: "",
    SUB_AFF: "sub_aff",
    KYC_PAYMENT: "kyc-payment-internal",
    KYC_REQUEST: "kyc-request",
};
export const ACTIVITY_STATUS = {
    PRE_SALE: "",
    CLAIM_REWARD: "",
    SUB_AFF: "sub_aff",
};

export const ITEM_PER_PAGE = 5;
export const MAX_CHARACTERS_IN_DESCRIPTION = 150;
export const MAX_CHARACTERS_IN_USERNAME = 20;
export const NICK_NAME_REGEX = /^(?!\s)(?!.*[?!'":;_+\-=/*\[\]{}#$%@^()~\\|<>^_]).{1,20}$/;

export enum OTP_TYPE {
    WITHDRAW_BONUS = "withdraw-bonus",
    CLAIM_BOOST_INTEREST = "claim-boost-interest",
    CLAIM_BOOST_PRINCIPLE = "claim-boost-principal",
    LINK = "link",
    DISCONNECT = "disconnect",
    CONNECT_2FA = "link-authenticator",
    DISCONNECT_2FA = "disconnect-authenticator",
    CHANGE_2FA = "change-authenticator",
    EMAIL = "email",
    GOOGLE_AUTHENTICATOR = "google_authenticator",
    OTP_RESET_PASSWORD = "reset-password",
    OTP_RESET_PIN = "reset-pin",
    OTP_RECOVERY_DOTP = "recovery-dotp",
    OTP_SETUP_DOTP = "setup-dotp",
    OTP_ACTIVE_DEVICE = "active-device",
    OTP_FORGOT_PIN = "forgot-pin",
    CLAIM_NFT_TO_ADDRESS = "claim-nft-to-address",
}
export enum CLAIM_TYPE {
    CLAIM_BOOST_INTEREST = "claim-boost-interest",
    CLAIM_BOOST_PRINCIPLE = "claim-boost-principal",
    WITHDRAW_BONUS = "withdraw-bonus-internal",
}
export enum TRANSACTION_TYPE {
    CLAIM_BOOST_INTEREST = "claim-boost-interest-internal",
    CLAIM_BOOST_PRINCIPLE = "claim-boost-principal-internal",
    WITHDRAW_BONUS = "withdraw-bonus-internal",
    BOOST = "boost-internal",
    GIFT = "gift-internal",
    PRE_SALE = "presale-internal",
    SWAP = "convert",
    WITHDRAW = "withdrawn",
    DEPOSIT = "deposit",
    UPDATE_PROFILE = "update-info-internal",
    TRANSFER = "transfer-internal",
    CREATE_NFT = "create-custom-nft",
    WITHDRAW_NFT = "withdraw-custom-nft",
    BOOST_PACKAGE = "boost-package",
    BONUS_AFF = "bonus-aff",
    ALL = "all",
}
export enum TRANSACTION_STATUS {
    SUCCESS = "success",
    PROCESSING = "processing",
    FAILED = "failed",
}
export const DEVTOOLS_URL = "https://remote-devtools-production.up.railway.app/target.js";
export const IS_PRODUCTION = process.env.NODE_ENV == "production";

export const CHARACTER_POSITION_DETECT = "<|";
export enum DETAIL_TRANSACTION_TYPE {
    TEXT = "text",
    TEXT_IMAGE = "text-img",
    // FEE = "fee",
    HASH = "hash",
    ARRAY_TEXT = "array-text",
}
export enum RESULT_TYPE {
    GIFT = "gift",
    TRANSFER = "transfer",
}

export const MAX_WIDTH_LIMIT = 600;
export const STANDARD_MOBILE_RATIO = 0.4618226601;
export const OVERRIDE_DEBUG = Boolean(process.env.NEXT_PUBLIC_OVERRIDE_DEBUG);

export enum PAYMENT_TYPE {
    WALLET_TBK = "wallet-tbk",
    SUB_PAYMENT = "sub-payment",
}
export enum PAYMENT_STATUS {
    SUCCESS = "success",
    FAILED = "failed",
    PENDING = "pending",
    EXPIRED = "expired",
}

export const QR_BLUR_DATA_URL =
    "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/4gHYSUNDX1BST0ZJTEUAAQEAAAHIAAAAAAQwAABtbnRyUkdCIFhZWiAH4AABAAEAAAAAAABhY3NwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAA9tYAAQAAAADTLQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAlkZXNjAAAA8AAAACRyWFlaAAABFAAAABRnWFlaAAABKAAAABRiWFlaAAABPAAAABR3dHB0AAABUAAAABRyVFJDAAABZAAAAChnVFJDAAABZAAAAChiVFJDAAABZAAAAChjcHJ0AAABjAAAADxtbHVjAAAAAAAAAAEAAAAMZW5VUwAAAAgAAAAcAHMAUgBHAEJYWVogAAAAAAAAb6IAADj1AAADkFhZWiAAAAAAAABimQAAt4UAABjaWFlaIAAAAAAAACSgAAAPhAAAts9YWVogAAAAAAAA9tYAAQAAAADTLXBhcmEAAAAAAAQAAAACZmYAAPKnAAANWQAAE9AAAApbAAAAAAAAAABtbHVjAAAAAAAAAAEAAAAMZW5VUwAAACAAAAAcAEcAbwBvAGcAbABlACAASQBuAGMALgAgADIAMAAxADb/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCABlAGUDASIAAhEBAxEB/8QAGwAAAwEBAQEBAAAAAAAAAAAAAAQFAwIGAQf/xAAfEAACAgMBAQADAAAAAAAAAAAAAwECBCExYRIRE0H/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/8QAFBEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8A/f7zoSyJ1Jve+hLIv0Cdlz0jZU7kp5d+kbKvuQFGTsKTsxZfYUvsCmiSgmSQi/CglgFGs6C0mFL6PtrgfGSKsk0ZcVZcAmQMpuAHs7s0JZDenN26E8hupAWy2dIuU3o5lt7siZbegcMbs+UbsQa7fTmrtgXUO9KCXennUP8ASgl/oFyjTqWkyjvTuXegNMaLXYY3cYXaAxLAEpaAHrLt0J5DdSfLs0J5F9AK5bekTLb0fy79ImXfoC7m7Mqu30WffZhDNgWkv9KCX+nnktH0tAvLf6afu9JK2+msNAes4xs0WlhnZgDMtAT/AGAB7K06E3zqRu0aFXxoCTlz0i5f9LmVXpGyqdAjP6LfnY8+mxWabA6VYdTYTXUbVADq7m0WFlwbRAHc2OZsH4OZAPoDn8AB+gWpoVdQp2XoWcvQEPJX0k5K+noshfSXkK6B556titlb4WXKF7J3wBCihhazeqvDaigMqUNYob1WdfrAWmpzNRuaHE0AV+QGPgAP0e1BdtChauhZtQJGQvpNyFlp9ek59QIzVi9lFJtBe1AFYWa1WaxQ0rUDKFnXwbxU+/ICs0OJoNWqZzUBf4A2+QA/Q7cF2gACD/6Tn/0AARbAvYAAINKwAAdwEgAHFjOwAByAAB//2Q==";

export const space = "a9a2a6a3-875c-4665-a67e-9772f2f3da49-3142b276-d94a-4412-92ac-6d7d46f60f90";
